<template>
  <div class="order-list">
    <el-card class="query-card">
      <el-form :model="UnNormalProcessReqVO" ref="queryForm" label-width="auto" size="small" inline>


        <el-row :gutter="30" style="display: flex; flex-wrap: wrap; align-items: center;">

          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item :label="$t('startDate')" prop="startTime">
              <el-date-picker
                v-model="UnNormalProcessReqVO.startTime"
                type="datetime"
                :placeholder="$t('startDate')"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                class="full-width"
                :clearable="false"
                :editable="false"
              />
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item :label="$t('endDate')" prop="endTime">
              <el-date-picker
                v-model="UnNormalProcessReqVO.endTime"
                type="datetime"
                :placeholder="$t('endDate')"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                class="full-width"
                :clearable="false"
                :editable="false"
              />
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item :label="$t('forwardRefundmentList.tradeNo')" prop="upTrNo">
              <div class="input-with-more">
                <el-input v-model="UnNormalProcessReqVO.upTrNo" :placeholder="$t('please_input')" clearable class="full-width" />
              </div>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item :label="$t('forwardRefundmentList.TimeType')" prop="dateType">
              <el-select v-model="UnNormalProcessReqVO.dateType" :placeholder="$t('choose')"  class="full-width">
                <el-option :label="$t('forwardRefundmentList.tradingTime')" value="0"></el-option>
                <el-option :label="$t('forwardRefundmentList.applyTime')" value="1"></el-option>
                <el-option :label="$t('forwardRefundmentList.proTime')" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item :label="$t('forwardRefundmentList.merOrderNO')" prop="trMerOrderno">
              <div class="input-with-more">
                <el-input v-model="UnNormalProcessReqVO.trMerOrderno" :placeholder="$t('please_input')" clearable class="full-width" />
              </div>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item :label="$t('forwardRefundmentList.processstatus')" prop="upStatus">
              <el-select v-model="UnNormalProcessReqVO.upStatus" :placeholder="$t('choose')" clearable class="full-width">
                <el-option :label="$t('forwardRefundmentList.fail')" value="-1"></el-option>
                <el-option :label="$t('forwardRefundmentList.waitdispose')" value="0"></el-option>
                <el-option :label="$t('forwardRefundmentList.checkSuccessButNotProcess')" value="1"></el-option>
                <el-option :label="$t('forwardRefundmentList.success')" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>



          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item :label="$t('forwardRefundmentList.rdrTagPrompt')" prop="rdrTag">
              <el-select v-model="UnNormalProcessReqVO.rdrTag" :placeholder="$t('choose')" clearable class="full-width">
                <el-option :label="$t('forwardRefundmentList.yes')" value="1"></el-option>
                <el-option :label="$t('forwardRefundmentList.no')" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>


          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8" v-if="refundIsCheck == 1">
            <el-form-item :label="$t('forwardRefundmentList.mercheckStatus')" prop="upMercheckStatus">
              <el-select v-model="UnNormalProcessReqVO.upMercheckStatus" :placeholder="$t('choose')" clearable class="full-width">

                <el-option :label="$t('forwardRefundmentList.mercheckStatus0')" value="0"></el-option>
                <el-option :label="$t('forwardRefundmentList.mercheckStatus1')" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>





          <el-col :span="24">
            <el-form-item style="display: flex; justify-content: center; margin-top: 20px; margin-bottom: 10px;" label-width="0">
              <el-button type="primary" @click="handleSearch">{{ $t('query') }}</el-button>
              <el-button @click="handleReset">{{ $t('reset') }}</el-button>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </el-card>



    <div class="action-toolbar">

      <el-button
        v-if="hasPermission('refundment/forwardRefundmentList', 'downExcel')"
        :disabled="!hasSearched"
        :loading="downloadLoading"
        @click="handledownload"
        type="primary"
        icon="el-icon-download"
      >
        {{ $t('button.download') }}
      </el-button>


      <el-button
        v-if="hasPermission('refundment/forwardRefundmentList', 'button_recheck')"
        :disabled="selectedRowIds.length === 0"
        :loading="auditLoading"
        @click="handleAudit"
        type="success"
        icon="el-icon-s-check"
      >
        {{ $t('button.check') }}
      </el-button>


    </div>


    <el-card class="table-card" style="margin-top: 16px; overflow-x: auto;">
      <el-table :data="tableData" @sort-change="handleSortChange" border  style="width: 100%" v-loading="loading" show-overflow-tooltip
                :cell-style="{whiteSpace: 'nowrap'}"
                :header-cell-style="{whiteSpace: 'nowrap'}"
      >

<!--        <el-table-column
          v-if="refundIsCheck == 0"
          width="120" align="center" :label="$t('choose')">
          <template slot-scope="scope" v-if="scope.row.upMercheckStatus == 0">
            <el-radio
              v-model="selectedRowId"
              :label="scope.row.upId"
              @change="handleRadioChange(scope.row)"
            >
              {{''}}
            </el-radio>
          </template>
        </el-table-column>-->
        <el-table-column
          v-if="refundIsCheck == 1"
          width="120"
          align="center">

          <template slot="header" slot-scope="scope">
            <el-checkbox
              v-model="checkAll"
              :indeterminate="isIndeterminate"
              @change="handleCheckAllChange">
              {{ $t('selectAll') }}
            </el-checkbox>
          </template>

          <template slot-scope="scope">
            <el-checkbox
              v-if="scope.row.upMercheckStatus == 0"
              v-model="selectedRowIds"
              :label="scope.row.upId"
              @change="handleCheckboxChange"
            >
              {{''}}
            </el-checkbox>
          </template>
        </el-table-column>

        <el-table-column prop="upId"  label="Refund ID" width="100"></el-table-column>

        <el-table-column prop="upTrNo" :label="$t('forwardRefundmentList.tradeNo')" :min-width="columnWidths.tradeNo"></el-table-column>
        <el-table-column prop="trMerOrderno" :label="$t('forwardRefundmentList.merOrderNO')" :min-width="columnWidths.merOrderNO"></el-table-column>


        <el-table-column
          v-if="refundIsCheck == 1"
          prop="upMercheckStatus"
          :label="$t('forwardRefundmentList.mercheckStatus')"
          :min-width="columnWidths.mercheckStatus"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.upMercheckStatus == 1 ? 'success' : 'warning'">
              {{ scope.row.upMercheckStatus == 1 ? $t('forwardRefundmentList.mercheckStatus1') : (scope.row.upMercheckStatus == 0 ? $t('forwardRefundmentList.mercheckStatus0') : $t('forwardRefundmentList.statusUnknown')) }}
            </el-tag>
          </template>
        </el-table-column>


<!--        <el-table-column prop="upCurrency" :label="$t('forwardRefundmentList.refundamount')" :min-width="columnWidths.refundamount"></el-table-column>-->

        <el-table-column :label="$t('forwardRefundmentList.refundamount')" :min-width="columnWidths.refundamount">
          <template slot-scope="scope">
            <span>{{ scope.row.upCurrency }}&nbsp; {{ scope.row.upAmount }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="upReason" :label="$t('forwardRefundmentList.refundreason')" :min-width="columnWidths.refundreason"></el-table-column>

        <el-table-column :label="$t('forwardRefundmentList.processstatus')" :min-width="columnWidths.processstatus">
          <template slot-scope="scope">
          <span>
            <span v-if="scope.row.upStatus == -1">{{ $t('forwardRefundmentList.fail') }}</span>
            <span v-else-if="scope.row.upStatus == 0">{{ $t('forwardRefundmentList.waitdispose') }}</span>
            <span v-else-if="scope.row.upStatus == 1">{{ $t('forwardRefundmentList.checkSuccessButNotProcess') }}</span>
            <span v-else-if="scope.row.upStatus == 2">{{ $t('forwardRefundmentList.success') }}</span>
            <span v-else>{{ $t('statusUnknown') }}</span>
          </span>
          </template>
        </el-table-column>

        <el-table-column prop="upLoginName" :label="$t('forwardRefundmentList.operater')" :min-width="columnWidths.operater"></el-table-column>
        <el-table-column prop="upOprtime" :label="$t('forwardRefundmentList.refundtime')" :min-width="columnWidths.refundtime"></el-table-column>
        <el-table-column prop="upExetime" :label="$t('forwardRefundmentList.processtime')" :min-width="columnWidths.processtime"></el-table-column>
        <el-table-column prop="trDatetime" :label="$t('forwardRefundmentList.tradingTime')" :min-width="columnWidths.tradingTime"></el-table-column>
        <el-table-column prop="trWebsite" :label="$t('forwardRefundmentList.returnurl')" :min-width="columnWidths.returnurl"></el-table-column>
        <el-table-column prop="trReturnurl" :label="$t('forwardRefundmentList.website')" :min-width="columnWidths.website"></el-table-column>
        <el-table-column prop="ciEmail" :label="$t('forwardRefundmentList.email')" :min-width="columnWidths.email"></el-table-column>




      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 16px; text-align: right;"
      />
    </el-card>


  </div>




</template>

<script>
import { hasPermission } from "@/utils/permission";
import { postDownload } from "@/utils/download";
export default {
  name: "OrderList",
  data() {
    return {
 /*     endPickerOptions: {
        disabledDate: (time) => {
          if (!this.SysMerOperatelogReqVo.startTime) {
            return false;
          }

          return (
            time.getTime() <
            new Date(this.SysMerOperatelogReqVo.startTime).getTime()
          );
        }
      },*/
      loading: false,
      refundIsCheck: null,
      UnNormalProcessReqVO: {
        dateType: '1',
        upStatus:'',
        upTrNo:"",
        trMerOrderno:"",
        upMercheckStatus:"",
        rdrTag:"",
        startTime: "",
        endTime: "",


        sortField: undefined,
        sortOrder: undefined
      },
      selectedRowData: "", // 当前行全部数据
      selectedRowIds: [],  // 选择id

      //全选控制变量
      checkAll: false,          // 是否全选
      isIndeterminate: false,   // 是否为半选状态（勾了一部分，没全勾）

      auditLoading: false,

      moreDialogVisible: false,


      hasSearched: false,   //  是否有进行查询




      checkAllCurrency: false,

      downloadLoading: false,
      tableData: [],

      columnWidths:{},
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
      },
      pages:"",

    };
  },
  created() {
    // this.handleSearch(); // 初始化加载数据
    this.setDefaultTime(); //时间设置
    this.refundIsCheck = sessionStorage.getItem("refundIsCheck");
  },
  mounted() {
    this.$nextTick(() => {
      this.initColumnWidths();
    });
  },
  // 发送变化重新计算
  computed:{
    selectableIds() {
      // 过滤出满足条件的行，提取它们的 upId
      return this.tableData
        .filter(item => item.upMercheckStatus == 0)
        .map(item => item.upId);
    }
  },
  methods: {
    setDefaultTime() {
      const now = new Date();

      // 当天开始时间
      const start = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        0,
        0,
        0
      );

      // 当天结束时间
      const end = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        23,
        59,
        59
      );

      this.UnNormalProcessReqVO.startTime = this.formatDateTime(start);
      this.UnNormalProcessReqVO.endTime = this.formatDateTime(end);
    },
    formatDateTime(date) {
      const pad = (n) => String(n).padStart(2, '0');

      return (
        date.getFullYear() +
        '-' +
        pad(date.getMonth() + 1) +
        '-' +
        pad(date.getDate()) +
        ' ' +
        pad(date.getHours()) +
        ':' +
        pad(date.getMinutes()) +
        ':' +
        pad(date.getSeconds())
      );
    },
    // 按钮
    hasPermission,
    // 排序
    handleSortChange({ column, prop, order }) {
      // prop 是排序的字段名 (例如 'tsId')
      // order 是排序方式：'ascending' (升序), 'descending' (降序), 或者 null (默认不排序)
      if (order === null) {
        this.UnNormalProcessReqVO.sortField = undefined;
        this.UnNormalProcessReqVO.sortOrder = undefined;
      } else {
        // 正常赋值升序或降序
        this.UnNormalProcessReqVO.sortField = prop;
        this.UnNormalProcessReqVO.sortOrder = order;
      }

      // 重新调用获取列表的接口
      this.fetchOrderList();
    },
    // 数据绑定
    handleRadioChange(row) {
      this.selectedRowData = row;
    },
    handleCheckAllChange(val) {
      // val 为 true 时全选，把当前页可以勾选的 ID 赋值给 selectedRowIds；否则清空
      this.selectedRowIds = val ? [...this.selectableIds] : [];
      this.isIndeterminate = false; // 取消半选状态的横杠样式
      console.log('当前选中的ID集合:', this.selectedRowIds);
    },
    // 审核
    handleCheckboxChange() {
      const checkedCount = this.selectedRowIds.length;
      const totalSelectableCount = this.selectableIds.length;

      // 如果当前选中的数量，等于当前能被选中的最大数量，说明全选了
      this.checkAll = checkedCount === totalSelectableCount && totalSelectableCount > 0;

      // 如果选中的数量大于 0，且没选满，就是半选状态
      this.isIndeterminate = checkedCount > 0 && checkedCount < totalSelectableCount;

    },async handleAudit() {
      // 二次确认，防止误操作
      this.$confirm(this.$t('selected')+` ${this.selectedRowIds.length} `+this.$t('record') +' ,'+this.$t('forwardRefundmentList.alert_check_confirm'), this.$t('tips'), {
        confirmButtonText: this.$t('sure'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(async () => {
        this.auditLoading = true;
        try {
          const res = await this.$axios.put('/api/unnormal/confirm', this.selectedRowIds);

          if (res.data.code === 0) {
            this.$message.success(this.$t('succeed'));
            // 清空选中状态
            this.selectedRowIds = [];
            this.checkAll = false;
            this.isIndeterminate = false;
            // 重新刷新列表数据
            this.fetchOrderList();
          } else {
            this.$message.error(res.data.msg || '审核失败');
          }
        } catch (error) {
          console.error('审核请求异常:', error);
          this.$message.error(this.$t('requestFailed'));
        } finally {
          this.auditLoading = false;
        }
      }).catch(() => {
        // 取消操作时不报错
        this.$message.info(this.$t('cancel'));
      });
    },



    // 查询
    handleSearch() {
      this.pagination.page = 1; // 重置页码
      this.fetchOrderList();
    },
    // 重置
    handleReset() {
      this.$refs.queryForm.resetFields();

      this.hasSearched = false;
      //this.handleSearch();
    },
    //
    async fetchOrderList() {
      this.loading = true;
      try {
        const params = {
          upTrNo: this.UnNormalProcessReqVO.upTrNo || undefined,
          trMerOrderno: this.UnNormalProcessReqVO.trMerOrderno || undefined,
          dateType: this.UnNormalProcessReqVO.dateType || undefined,
          upStatus: this.UnNormalProcessReqVO.upStatus || undefined,
          upMercheckStatus: this.UnNormalProcessReqVO.upMercheckStatus || undefined,
          rdrTag: this.UnNormalProcessReqVO.rdrTag || undefined,
          startTime: this.UnNormalProcessReqVO.startTime || undefined,
          endTime: this.UnNormalProcessReqVO.endTime || undefined,


          page: this.pagination.page,
          limit: this.pagination.limit,
        };

        const res = await this.$axios.post('/api/unnormal/merlist',  params );

        if (res.data.code === 0) {
          const responseData = res.data.data;

          this.tableData = responseData.records || [];

          this.pagination.total = Number(responseData.total) || 0;
          this.pagination.page = Number(responseData.current) || this.pagination.page;
          this.pagination.limit = Number(responseData.size) || this.pagination.limit;

          if (this.pagination.total > 0) {
            this.hasSearched = true;
          }
        } else {
          this.$message.error(res.data.msg);
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        console.error('查询订单失败:', err);
        this.$message.error(this.$t('requestFailed'));
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },
    // 下载
    async handledownload() {
      this.downloadLoading = true;
      this.$message.info(this.$t('DownloadInfo'));

      const params = {
        upTrNo: this.UnNormalProcessReqVO.upTrNo || undefined,
        trMerOrderno: this.UnNormalProcessReqVO.trMerOrderno || undefined,
        dateType: this.UnNormalProcessReqVO.dateType || undefined,
        upStatus: this.UnNormalProcessReqVO.upStatus || undefined,
        upMercheckStatus: this.UnNormalProcessReqVO.upMercheckStatus || undefined,
        rdrTag: this.UnNormalProcessReqVO.rdrTag || undefined,
        startTime: this.UnNormalProcessReqVO.startTime || undefined,
        endTime: this.UnNormalProcessReqVO.endTime || undefined,
      };

      try {
        const name = `退款记录明细_${new Date().getTime()}.xlsx`;
        const warningText = this.$t('export_truncated_warning');
        await postDownload('/api/unnormal/export', params , name, warningText);
        this.$message.success(this.$t('export_success'));
      } catch (e) {
        this.$message.error(e.message || this.$t('export_fail'));
      } finally {
        this.downloadLoading = false;
      }
    },

    // 分页：每页条数变化
    handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.page = 1; //
      this.fetchOrderList(); //
    },
    // 分页：当前页变化
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.fetchOrderList(); //
    },
    // 处理选择id
    handleRowClick(row) {
      this.selectedRowIds = row.tsId;

    },



    // 表头宽度
    initColumnWidths() {
      const cols = [
        "tradeNo",
        "merOrderNO",
        "mercheckStatus",
        "refundamount",
        "refundreason",
        "processstatus",
        "operater",
        "refundtime",
        "processtime",
        "tradingTime",
        "returnurl",
        "website",
        "email",

      ];
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      ctx.font = '14px Helvetica';

      cols.forEach(key => {
        const label = this.$t(
          `UnNormalProcessReqVO.${key}`
        );

        this.$set(
          this.columnWidths,
          key,
          Math.ceil(ctx.measureText(label).width) + 50
        );
      });
    }
  },
};
</script>

<style>
/* 全局样式 - 表头居中 */
.el-table th .cell {
  white-space: nowrap !important;
  text-align: center !important;
}

.el-table .cell {
  white-space: nowrap !important;
  text-align: center !important;
}
</style>

<style scoped>
.order-list {
  padding: 20px;
}

/* 确保输入框、下拉框、时间选择器在栅格中占满 100% 宽度 */
.full-width {
  width: 100% !important;
}

/* 使用 Flex 布局优雅处理 输入框 + More 按钮 的组合 */
.input-with-more {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-with-more .el-input {
  flex: 1; /* 让输入框自动撑满剩余空间 */
}

.input-with-more .el-button {
  margin-left: 10px; /* 按钮和输入框之间的间距 */
  flex-shrink: 0; /* 防止按钮被挤压变形 */
}

/* 保持表格原有样式不变 */
.table-card ::v-deep .el-table .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.table-card ::v-deep .el-table th .cell {
  white-space: nowrap !important;
}
.table-card {
  overflow-x: auto;
}

.table-card ::v-deep .el-table {
  min-width: 100%;
}


/* --- 修改 1：美化查询表单的标签字体 --- */
.query-card /deep/ .el-form-item__label {
  white-space: nowrap !important;
  font-weight: 600 !important; /* 强制加粗生效 */
  color: #303133 !important; /* 强制颜色深灰生效 */
  font-size: 14px !important;
  letter-spacing: 0.5px !important;
  min-width: 120px;
  text-align: right;
}


/* --- 修改 2：美化输入框内的字体和边框 --- */
.query-card /deep/ .el-input__inner {
  font-weight: 500 !important; /* 强制生效 */
  color: #606266 !important; /* 强制生效 */
  border-radius: 6px !important; /* 强制微圆角生效 */
}
/* 鼠标悬浮时输入框边框颜色加深一点点（可选增亮效果） */
.query-card /deep/ .el-input__inner:hover {
  border-color: #c0c4cc !important;
}

/* 操作工具栏样式 */
.action-toolbar {
  margin-top: 16px;     /* 与上方查询卡片拉开间距 */
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 按钮之间的间距调整 */
.action-toolbar .el-button {
  margin-left: 10px;
  margin-right: 0;
}

.drawer-form {
  padding-right: 20px;
}

/*侧边弹窗*/
.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  padding: 15px 20px;

  border-top: 1px solid #ebeef5;
  background: #fff;

  text-align: right;
}
::v-deep .el-drawer__body {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.drawer-form {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  padding-bottom: 80px;
}
.drawer-footer {
  flex-shrink: 0;
  padding: 15px 20px;
  border-top: 1px solid #ebeef5;
  background: #fff;
  text-align: right;
}




</style>



// WEBPACK FOOTER //
// src/view/refundment/forwardRefundmentList.vue